import { render, staticRenderFns } from "./ModulesView.vue?vue&type=template&id=2089445c&scoped=true&"
import script from "./ModulesView.vue?vue&type=script&lang=js&"
export * from "./ModulesView.vue?vue&type=script&lang=js&"
import style0 from "./ModulesView.vue?vue&type=style&index=0&id=2089445c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2089445c",
  null
  
)

export default component.exports